import { h } from 'preact';
import { createClassName, memo } from '../../helpers';
import { MessageBubble } from '../MessageBubble';
import styles from './styles.scss';
import { parentCall } from '../../../lib/parentCall';
export const ImageAttachment = memo(({
    url,
    attachments,
    attachmentResolver,
    className,
    ...messageBubbleProps
}) => {
	const img_download = attachmentResolver(attachments.title_link_download == true?attachments.title_link:url);
    const handleImageClick = (e) => {
        e.preventDefault(); // Prevent default behavior
        e.stopPropagation(); // Stop event bubbling
        // console.log('Image clicked:', url); // Debug log
        parentCall('SHOW_IMAGE_PREVIEW', [img_download]);
    };

    const handleRightClick = (e) => {
        e.preventDefault(); // Disable right-click context menu
    };

    return (
        <MessageBubble
            nude
            className={createClassName(styles, 'image-attachment', {}, [className])}
            {...messageBubbleProps}
        >
            <div className={createClassName(styles, 'image-container')}>
                <img
                    src={url}
                    className={createClassName(styles, 'image-attachment__inner')}
                    onClick={handleImageClick}
                    onContextMenu={handleRightClick} // Disable right-click on image
                    style={{ cursor: 'pointer' }} // Add pointer cursor to indicate clickability
                />
                <div 
                    className={createClassName(styles, 'hover-text')}
                    onClick={handleImageClick}
                >
                    CLICK TO PREVIEW & DOWNLOAD
                </div>
            </div>
        </MessageBubble>
    );
});
